const camelize = (str: string) => {
  return str.trim().replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (+match === 0) return ''; // Removes spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
};

export default camelize;
